import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100">
      <header className="sticky top-0 z-40 border-b border-slate-800/80 bg-[#0B0F17]/85 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <button
            data-testid="brand-home-link"
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-3"
          >
            <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-slate-900" strokeWidth={2.4} />
            </div>
            <div className="text-left">
              <p className="font-heading font-extrabold leading-none tracking-tight">LegitimoCAD <span className="text-cyan-400">Pro</span></p>
              <p className="font-mono-t text-[9px] tracking-widest text-slate-500 uppercase mt-0.5">Conformità Edilizia</p>
            </div>
          </button>

          <div className="flex items-center gap-3">
            {user && (
              <div className="flex items-center gap-2.5">
                {user.picture ? (
                  <img data-testid="user-profile-avatar" src={user.picture} alt="" className="h-8 w-8 rounded-full border border-slate-700" />
                ) : (
                  <div className="h-8 w-8 rounded-full bg-cyan-500/20 flex items-center justify-center text-cyan-300 text-sm font-medium">
                    {user.name?.[0] || "U"}
                  </div>
                )}
                <div className="hidden sm:block">
                  <p className="text-sm font-medium leading-none">{user.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{user.email}</p>
                </div>
              </div>
            )}
            <button
              data-testid="logout-button"
              onClick={logout}
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-slate-100 hover:bg-slate-800 transition-colors"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Esci</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
};
